// extracted by mini-css-extract-plugin
export default {"newButton":"ct2jA1","withStyles":"AwWHxQ","withOldStyles":"SaXbDO"};